/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/core/styles';
import { push } from 'connected-react-router';
import Dialog from './dialog';
import get from 'lodash/get';
import {
  getGlassChecklistPerformedFilesDownloadInfo,
  getNeedCaseFileDownloadInfo,
} from 'utils/projectFiles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { EUROPE } from 'enums/regions';
import { toast } from 'react-toastify';
import toastConfig from 'enums/toast';
import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const Actions = ({ push, value, row }) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const isClient = get(row, 'data.status', '') === 'Cliente';
  const isClosed = row.isClosed;

  const needCase = get(row, 'data.needCase') === true;
  const data = row?.data ?? {};
  const needCaseFile = getNeedCaseFileDownloadInfo(data);
  const glassCheckListPerformed =
    get(row, 'data.glassCheckListPerformed') === true;
  const glassChecklistFiles = getGlassChecklistPerformedFilesDownloadInfo(data);

  // TODO: issue dd5b5f54-99ee-4b5d-8965-7e22733c2d12, this can unified in a hook or utils function
  const handleDownloadNeedCaseFile = async () => {
    if (!needCaseFile?.uuid) return;
    try {
      const downloadUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        needCaseFile.uuid,
      )}`;
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });
      const fallbackName =
        needCaseFile.name ||
        (needCaseFile.key &&
          needCaseFile.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  // TODO: issue dd5b5f54-99ee-4b5d-8965-7e22733c2d12, this can unified in a hook or utils function
  const handleDownloadGlassFile = async (file) => {
    if (!file?.uuid) return;
    try {
      const downloadUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        file.uuid,
      )}`;
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });
      const fallbackName =
        file.name ||
        (file.key && file.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  const isEuropeCountry = EUROPE.includes(get(row, 'data.country'));
  const showDownloadNeedCase =
    isEuropeCountry && needCase && needCaseFile?.uuid;
  const showDownloadGlass =
    isEuropeCountry &&
    glassCheckListPerformed &&
    glassChecklistFiles.some((file) => file.uuid);

  const isAproved = row.isApproved;

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        &bull;&bull;&bull;
      </Button>

      {isClosed ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {/* Si está cerrado pero NO aprobado, mostramos únicamente la opción "Ver" */}
            {!isAproved ? (
              <MenuItem
                onClick={() => push(`/installer/building/view/${value}`)}
              >
                <VisibilityIcon className={classes.icon} />
                <FormattedMessage id="Ver" />
              </MenuItem>
            ) : (
              <>
                <MenuItem
                  onClick={() => push(`/installer/building/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>

                <MenuItem onClick={handleOpenDialog}>
                  <MailOutlineIcon className={classes.icon} />
                  <FormattedMessage id="Volver a enviar cert de garantía" />
                </MenuItem>
                {showDownloadNeedCase && (
                  <MenuItem onClick={handleDownloadNeedCaseFile}>
                    <GetAppIcon className={classes.icon} />
                    <FormattedMessage id="Descargar certificado" />
                  </MenuItem>
                )}
                {showDownloadGlass && (
                  <>
                    {glassChecklistFiles
                      .filter((file) => file.uuid)
                      .map((file, index, files) => (
                        <MenuItem
                          key={file.uuid}
                          onClick={() => handleDownloadGlassFile(file)}
                        >
                          <GetAppIcon className={classes.icon} />
                          <FormattedMessage id="Descargar archivo" />
                          {files.length > 1 ? ` ${index + 1}` : ''}
                        </MenuItem>
                      ))}
                  </>
                )}
                {openDialog && (
                  <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    code={value}
                  />
                )}
              </>
            )}
          </Menu>
        </>
      ) : isClient ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => push(`/installer/building/edit/${value}`)}>
              <EditIcon className={classes.icon} />
              <FormattedMessage id="Editar" />
            </MenuItem>
            <MenuItem onClick={handleOpenDialog}>
              <MailOutlineIcon className={classes.icon} />
              <FormattedMessage id="Volver a enviar cert de garantía" />
            </MenuItem>
          </Menu>
          {openDialog && (
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              code={value}
            />
          )}
        </>
      ) : (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => push(`/installer/building/edit/${value}`)}>
            <EditIcon className={classes.icon} />
            <FormattedMessage id="Editar" />
          </MenuItem>
          <MenuItem onClick={() => push(`/installer/building/win/${value}`)}>
            <AssignmentTurnedInIcon className={classes.icon} />
            <FormattedMessage id="Cambiar proyecto a ganado" />
          </MenuItem>
        </Menu>
      )}
    </>
  );
};

export default connect(undefined, { push })(Actions);
